module.exports = __webpack_public_path__ + "03_bob_gold.5877293b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/03_bob_gold.png
// module id = CF2O
// module chunks = 0